{
  "app": { "backoffice": "Backoffice" },
  "nav": { "dashboard": "Tableau de bord", "users": "Utilisateurs", "organizations": "Organisations", "invoices": "Factures", "mail": "E-mails", "audit": "Audit", "insights": "Qualité", "conversations": "Conversations", "offers": "Offres", "packs": "Packs de crédits", "prices": "Prix", "orders": "Commandes", "contact": "Demandes de contact", "waitlist": "Liste d'attente", "credits": "Crédits", "vat": "TVA à vérifier", "monthly": "Mois", "issues": "Problèmes", "sandboxes": "Bacs à sable" },
  "header": { "signOut": "Se déconnecter", "language": "Langue" },
  "common": {
    "loading": "Chargement…",
    "empty": "Rien ici.",
    "any": "Tous",
    "yes": "Oui",
    "no": "Non",
    "search": "Rechercher",
    "reset": "Réinitialiser les filtres",
    "cancel": "Annuler",
    "create": "Créer",
    "save": "Enregistrer",
    "saved": "Enregistré.",
    "delete": "Supprimer",
    "edit": "Modifier",
    "change": "changer",
    "count": "{{count}} au total",
    "range": "{{from}}–{{to}} sur {{total}}",
    "previous": "Page précédente",
    "next": "Page suivante",
    "typeToConfirm": "Tapez « {{word}} » pour confirmer"
  },
  "chart": { "showTable": "Tableau", "showChart": "Graphique", "period": "Période", "value": "Valeur" },
  "login": {
    "title": "Sculpt Backoffice",
    "subtitle": "Réservé à l'équipe Peerception : connectez-vous avec votre compte Microsoft Peerception.",
    "microsoft": "Continuer avec Microsoft",
    "finishing": "Connexion en cours…",
    "staffOnlyTitle": "Réservé à l'équipe",
    "staffOnlyMessage": "Ce compte n'est pas un compte de l'équipe Peerception. Demandez l'accès à un collègue qui a le backoffice.",
    "sso": {
      "staff_only": "Ce compte Microsoft n'est pas un compte de l'équipe Peerception.",
      "staff_tenant_only": "Ce compte Microsoft est hors du tenant Peerception. Connectez-vous avec votre compte Microsoft Peerception.",
      "sso_failed": "La connexion Microsoft a échoué. Réessayez.",
      "cancelled": "Connexion annulée.",
      "account_disabled": "Ce compte est désactivé."
    }
  },
  "dashboard": {
    "title": "Tableau de bord",
    "subtitle": "Où en est Sculpt aujourd'hui.",
    "usersTotal": "Utilisateurs",
    "usersVerified": "Vérifiés",
    "usersActive": "Actifs",
    "usersStaff": "Équipe",
    "of": "sur {{total}}",
    "orgsTotal": "Organisations",
    "operations": "Opérations",
    "invoicesOutstanding": "Factures en attente",
    "invoicesDraft": "Brouillons de facture",
    "outboxQueued": "E-mails en file",
    "outboxFailed": "E-mails en échec",
    "signupsPerWeek": "Inscriptions par semaine",
    "spendPerMonth": "Usage au prix client par mois (EUR)",
    "costPerMonth": "Coût fournisseur des appels clients par mois (USD)",
    "internalCostPerMonth": "Coût fournisseur des appels de Peerception par mois (USD)"
  },
  "users": {
    "discovery": "Nous a connus par",
    "discoverySource": { "linkedin": "LinkedIn", "google": "Google", "youtube": "YouTube", "word_of_mouth": "Bouche à oreille", "other": "Autre", "invitation": "Invitation" },
    "review": { "title": "Échantillon de relecture", "none": "Pas d'opposition : ses conversations peuvent être tirées au sort pour la relecture.", "objectedSince": "Opposition enregistrée le {{date}} : ses conversations ne sont plus tirées au sort.", "organizationOut": "Son organisation est hors de l'échantillon depuis le {{date}}.", "hint": "À enregistrer quand la personne le demande, par e-mail. Ses conversations en échec, signalées ou notées négativement restent relues ; le portail lui montre son statut.", "record": "Enregistrer l'opposition", "withdraw": "Retirer l'opposition", "recorded": "Opposition enregistrée.", "withdrawn": "Opposition retirée.", "recordTitle": "Enregistrer l'opposition", "recordMessage": "{{email}} s'oppose à la relecture de ses conversations tirées au sort. Les relectures déjà tirées au sort pour cette personne sont supprimées." },
    "title": "Utilisateurs",
    "new": "Nouvel utilisateur",
    "newSubtitle": "Un compte créé par l'équipe est vérifié d'emblée, sans mot de passe : la personne en choisit un via le lien envoyé.",
    "searchPlaceholder": "e-mail ou nom",
    "email": "E-mail",
    "name": "Nom",
    "firstName": "Prénom",
    "lastName": "Nom",
    "locale": "Langue",
    "organization": "Organisation",
    "organizationId": "Organisation n°",
    "organizationHint": "Laissez vide pour une organisation personnelle.",
    "verified": "Vérifié",
    "active": "Actif",
    "staff": "Équipe",
    "spend": "Facturé",
    "cost": "Coût fournisseur",
    "requests": "Appels modèle",
    "lastConnection": "Dernière connexion",
    "createdAt": "Créé le",
    "password": "Mot de passe",
    "ssoOnly": "aucun (Microsoft seulement)",
    "hasPassword": "défini",
    "makeStaff": "Équipe : peut utiliser ce backoffice",
    "sendReset": "Envoyer un lien « choisissez votre mot de passe »",
    "account": "Compte",
    "activeHint": "Actif (décocher révoque toutes les sessions)",
    "staffHint": "Équipe (accès au backoffice)",
    "verifiedHint": "E-mail vérifié (ouvre l'accès à l'assistant)",
    "usage": "Utilisation",
    "identities": "Identités liées",
    "noIdentities": "Aucune identité Microsoft liée.",
    "noOrganization": "Aucune organisation.",
    "sendResetAction": "Envoyer une réinitialisation",
    "resetSent": "E-mail de réinitialisation mis en file.",
    "moveAction": "Déplacer vers une organisation…",
    "moveTitle": "Déplacer vers une autre organisation",
    "moveHint": "Son organisation personnelle, si elle se vide, est archivée. Le propriétaire d'une équipe avec des membres ne peut pas être déplacé.",
    "moveConfirm": "Déplacer",
    "moved": "Déplacé.",
    "deleteAction": "Supprimer le compte…",
    "deleteTitle": "Supprimer ce compte",
    "deleteMessage": "Les conversations, classeurs, identités et sessions de {{email}} sont supprimés. Sa dépense modèle reste à l'organisation. Irréversible.",
    "deleteConfirm": "Supprimer le compte",
    "auditTitle": "Journal d'audit"
  },
  "orgs": {
    "reviewSample": { "title": "Échantillon de relecture", "in": "Dans l'échantillon de la relecture.", "out": "Hors de l'échantillon de la relecture depuis le {{date}} (choix du propriétaire dans le portail). Ses conversations en échec, signalées ou notées négativement restent relues." },
    "title": "Organisations",
    "new": "Nouvelle organisation",
    "newSubtitle": "Une organisation équipe ; invitez son premier admin tout de suite si vous le connaissez.",
    "searchPlaceholder": "nom ou e-mail de facturation",
    "name": "Nom",
    "kindLabel": "Type",
    "kind": { "team": "Équipe", "personal": "Personnelle" },
    "statusLabel": "Statut",
    "status": { "active": "Active", "suspended": "Suspendue", "archived": "Archivée" },
    "suspendedWarning": "Suspendue ferme l'accès à l'assistant pour tous les membres immédiatement.",
    "archivedWarning": "Une organisation archivée garde sa dépense et ses factures ; ses membres n'ont plus accès.",
    "plan": "Offre",
    "seats": "Sièges",
    "seatsHint": "Indicatif, non appliqué.",
    "allowance": "Allocation (USD)",
    "allowanceHint": "Dépense modèle au prix catalogue que l'organisation peut utiliser par période.",
    "periodLabel": "Période",
    "period": { "total": "total", "month": "mois" },
    "unlimited": "illimitée",
    "unlimitedHint": "Allocation illimitée",
    "billing": "Facturation",
    "billingEmail": "E-mail de facturation",
    "billingEmailHint": "Les factures partent ici ; vide = l'adresse du propriétaire.",
    "currency": "Devise",
    "currencyHint": "Celle de ses prix et de ses factures. Ne change que tant qu'elle n'a rien payé : un abonnement gratuit passe à la même offre dans cette devise, les commandes en attente sont recalculées.",
    "changeCurrency": "Changer de devise",
    "currencySaved": "L'organisation est désormais facturée en {{currency}}.",
    "billingName": "Raison sociale",
    "billingAddress": "Adresse de facturation",
    "vat": "Numéro de TVA",
    "notes": "Notes internes",
    "notesHint": "Jamais visibles par l'organisation.",
    "firstAdmin": "Premier admin (e-mail)",
    "firstAdminHint": "Invité comme admin dès la création.",
    "members": "Membres",
    "spend": "Facturé",
    "cost": "Coût fournisseur",
    "roleLabel": "Rôle",
    "role": { "owner": "Propriétaire", "admin": "Admin", "member": "Membre" },
    "tabs": { "overview": "Général", "subscription": "Abonnement", "members": "Membres", "claims": "Domaines", "invitations": "Invitations", "usage": "Utilisation", "invoices": "Factures" },
    "joinedAt": "Arrivé le",
    "makeOwner": "Rendre propriétaire",
    "transferTitle": "Transférer la propriété",
    "transferMessage": "{{email}} devient propriétaire ; le propriétaire actuel devient admin.",
    "transferConfirm": "Transférer",
    "transferred": "Propriété transférée.",
    "claimsHint": "Une revendication vérifiée avec adhésion automatique place tout nouvel inscrit de ce domaine ou de ce tenant dans cette organisation.",
    "claimKind": "Type",
    "claim": { "domain": "Domaine e-mail", "tenant": "Tenant Microsoft" },
    "claimValue": "Valeur",
    "autoJoin": "Adhésion auto",
    "claimStatus": "Statut",
    "verified": "vérifiée",
    "pending": "en attente",
    "verify": "Vérifier",
    "claimVerified": "Revendication vérifiée.",
    "noClaims": "Aucune revendication.",
    "invite": "Inviter",
    "invited": "Invitation envoyée à {{email}}.",
    "sentAt": "Envoyée",
    "expiresAt": "Expire",
    "revoke": "Révoquer",
    "noInvitations": "Aucune invitation en attente.",
    "since": "depuis le",
    "limitReached": "allocation épuisée",
    "createdAt": "Créée le",
    "updatedAt": "Modifiée le",
    "archivedAt": "Archivée le",
    "picker": "Rechercher une organisation…",
    "pickerNone": "Rechercher une organisation (ou laisser vide)…"
  },
  "invoices": {
    "title": "Factures",
    "new": "Nouvelle facture",
    "newSubtitle": "Un brouillon : rien n'est envoyé tant que vous ne l'envoyez pas.",
    "number": "Numéro",
    "organization": "Organisation",
    "statusLabel": "Statut",
    "status": { "draft": "Brouillon", "sent": "Envoyée", "paid": "Payée", "void": "Annulée" },
    "amount": "Montant",
    "currency": "Devise",
    "description": "Description",
    "details": "Facture",
    "periodStart": "Début de période",
    "periodEnd": "Fin de période",
    "issuedAt": "Émise le",
    "dueAt": "Échéance",
    "externalRef": "Référence externe",
    "externalRefHint": "Identifiant comptable ou de prestataire de paiement.",
    "notes": "Notes internes",
    "lines": "Lignes",
    "addLine": "Ajouter une ligne",
    "noLines": "Aucune ligne : le montant se suffit.",
    "lineDescription": "Description",
    "quantity": "Qté",
    "unitPrice": "Prix unitaire",
    "linesTotal": "Total des lignes",
    "useTotal": "Utiliser comme montant",
    "pdf": "PDF",
    "uploadPdf": "Joindre un PDF…",
    "replacePdf": "Remplacer le PDF…",
    "downloadPdf": "Télécharger le PDF",
    "pdfUploaded": "PDF enregistré.",
    "send": "Envoyer",
    "resend": "Renvoyer",
    "sendTitle": "Envoyer cette facture",
    "sendMessage": "Envoie un e-mail à l'adresse de facturation de l'organisation, PDF joint.",
    "sendNoPdf": "Aucun PDF n'est joint : l'e-mail ne portera que le numéro et le montant. Envoyer quand même ?",
    "sent": "Facture envoyée.",
    "sentTo": "à {{to}}",
    "markPaid": "Marquer payée",
    "paidTitle": "Marquer comme payée",
    "paidAt": "Payée le",
    "paidAtHint": "Vide = aujourd'hui.",
    "paid": "Marquée payée.",
    "void": "Annuler",
    "voidTitle": "Annuler cette facture",
    "voidMessage": "Une facture annulée garde son numéro et ne peut plus être envoyée ni payée.",
    "voided": "Facture annulée.",
    "deleteTitle": "Supprimer ce brouillon",
    "deleteMessage": "Seuls les brouillons se suppriment ; le numéro n'est pas réutilisé.",
    "lifecycle": "Cycle de vie",
    "sentAt": "Envoyée le",
    "locked": "Une facture envoyée, payée ou annulée est en lecture seule.",
    "issuing": "en cours d'émission",
    "kind": {"label": "Type", "invoice": "Facture", "credit_note": "Avoir"},
    "provider": {"label": "Source", "qonto": "Qonto", "manual": "Manuelle"},
    "issue": {"label": "Émission", "pending": "En cours · {{step}}", "pendingRetry": "En cours · {{step}} · tentative {{attempts}}", "issued": "Émise", "failed": "Échec à l'étape {{step}}"},
    "step": {"client": "client", "draft": "brouillon", "finalize": "numérotation", "paid": "paiement", "pdf": "PDF", "send": "envoi", "credit": "avoir"},
    "vat": "TVA",
    "total": "Total TTC",
    "amountExcl": "HT",
    "credits": "Avoir de la facture {{number}}",
    "creditedBy": "Annulée par l'avoir {{number}}",
    "qontoRef": "Identifiant Qonto",
    "channel": "Envoyée par",
    "channels": {"mail": "e-mail", "einvoice": "facture électronique"},
    "attempts": "Tentatives",
    "lastError": "Dernière erreur",
    "billedTo": "Facturé à",
    "qontoNote": "Émise via Qonto, qui la numérote : elle ne se modifie que par un avoir.",
    "retry": "Relancer",
    "retried": "Rendue au service de facturation.",
    "creditNote": "Émettre un avoir",
    "creditTitle": "Avoir sur la totalité de la facture",
    "creditMessage": "Qonto émet un avoir sur la totalité de cette facture, ce qui l'annule dans Qonto, et l'avoir est envoyé au client par e-mail. C'est irréversible.",
    "creditReason": "Motif (imprimé sur l'avoir)",
    "creditQueued": "Avoir en file : le service de facturation l'émet via Qonto."
  },
  "credits": {
    "title": "Crédits",
    "subtitle": "Crédits mensuels et crédits des packs, pour chaque organisation, sur sa période en cours.",
    "monthly": "Crédits mensuels",
    "packs": "Crédits des packs",
    "allocated": "Alloués sur la période",
    "spent": "Consommés",
    "left": "Restants (perdus s'ils ne sont pas consommés au renouvellement)",
    "packSpent": "Consommés sur la période",
    "packBalance": "Solde en cours",
    "packExpired": "Expirés non consommés",
    "packsSold": "Vendus (depuis le début)",
    "packsGiven": "Offerts par le staff (depuis le début)",
    "organization": "Organisation",
    "offer": "Offre",
    "monthlyTotal": "Prix / mois",
    "monthlyUse": "Crédits mensuels consommés",
    "nextExpiry": "Prochaine expiration",
    "noOffer": "sans abonnement",
    "unlimited": "illimité",
    "exhausted": "épuisés",
    "filterOffer": "Offre",
    "onlyPacks": "Seulement les organisations qui consomment des packs",
    "note": "Les périodes passées ne sont pas conservées : ce qui restait des crédits mensuels au renouvellement n'est pas enregistré.",
    "inCurrency": "Les crédits de chaque organisation sont dans sa devise, jamais convertis ; les totaux ci-dessus les additionnent en euros au taux du jour. Le prix mensuel est dans la devise de l'abonnement.",
    "prorated": "prorata",
    "proratedHint": "Offre changée le {{date}}, en cours de période : les crédits mensuels ne comptent les {{full}} du nouveau palier que pour les jours restants."
  },
  "contact": {
    "title": "Demandes de contact",
    "subtitle": "Demandes envoyées par le formulaire de contact du site",
    "role": "Métier",
    "roles": { "modeller": "Modélisation", "lender": "Banque / prêteur", "investor": "Fonds / investisseur", "advisor": "Conseil, audit", "other": "Autre" },
    "statusLabel": "Statut",
    "status": { "new": "Nouvelle", "in_progress": "En cours", "done": "Traitée", "spam": "Spam" },
    "name": "Nom",
    "email": "E-mail",
    "company": "Société",
    "message": "Message",
    "noMessage": "Pas de message : la personne demande à être contactée.",
    "lang": "Langue",
    "page": "Page d'origine",
    "receivedAt": "Reçue le",
    "searchPlaceholder": "Nom, e-mail ou société",
    "visitor": "Visiteur",
    "handling": "Suivi",
    "handledBy": "Traitée par",
    "handledAt": "Traitée le",
    "note": "Note interne",
    "noteHint": "Réservée à l'équipe ; le visiteur ne la voit jamais.",
    "reply": "Répondre par e-mail",
    "replySubject": "Votre demande Sculpt"
  },
  "waitlist": {
    "title": "Liste d'attente",
    "subtitle": "Inscriptions depuis la page Project Finance Agent de www.peerception.io",
    "email": "E-mail",
    "role": "Rôle",
    "roles": { "modeller": "Modélisation", "lender": "Banque / prêteur", "investor": "Fonds / investisseur", "advisor": "Conseil, audit", "other": "Autre" },
    "lang": "Langue",
    "createdAt": "Inscrit le"
  },
  "mail": {
    "title": "File d'e-mails",
    "statusLabel": "Statut",
    "status": { "queued": "En file", "sent": "Envoyé", "failed": "Échec" },
    "to": "Destinataire",
    "template": "Modèle",
    "subject": "Objet",
    "attempts": "Tentatives",
    "scheduledAt": "Planifié",
    "sentAt": "Envoyé le",
    "fields": "Envoi",
    "providerId": "Id prestataire",
    "attachment": "Pièce jointe",
    "lastError": "Dernière erreur",
    "params": "Paramètres",
    "preview": "Aperçu",
    "text": "Texte",
    "retry": "Réessayer maintenant"
  },
  "audit": {
    "title": "Journal d'audit",
    "when": "Quand",
    "action": "Action",
    "actionHint": "Préfixe, ex. admin. ou invoice.",
    "target": "Cible",
    "targetKind": "Type de cible",
    "targetId": "Id de cible",
    "actor": "Acteur",
    "data": "Données"
  },
  "quality": {
    "restrictedTitle": "Conversation restreinte",
    "restrictedText": "Cette conversation est hors de l'échantillon de la relecture : son organisation s'en est retirée, ou la personne s'y est opposée. Rien n'y relève du garde-fou (ni échec, ni signalement, ni pouce bas) : elle ne s'ouvre que pour une demande de support, inscrite au journal d'audit.",
    "openForSupport": "Ouvrir pour une demande de support",
    "restrictedRow": "Conversation restreinte",
    "downloadThread": "Télécharger la conversation",
    "replay": "Rejouer sur le code de production",
    "replayTitle": "Rejeu",
    "accept": "Accepter comme référence",
    "acceptAgain": "Remplacer la référence par ce résultat",
    "acceptHelp": "Ce résultat est-il correct ? Accepter fige ce que le code produit maintenant comme référence : cette conversation devient un eval, rejoué avant chaque release, et sa version d'index est conservée.",
    "acceptReasonPlaceholder": "Ce que cet eval protège, en une phrase",
    "goldenTitle": "Dans le corpus de rejeu",
    "goldenLine": "Référence acceptée le {{when}} par {{who}}, code {{version}}, {{calls}} appel(s) serveur.",
    "goldenLastRun": "dernier passage : {{outcome}} le {{when}} (code {{version}})",
    "retire": "Retirer la référence",
    "replayHelp": "Rejoue la partie serveur de cette conversation sur le code actuel, décisions du modèle inchangées. Dit seulement si le résultat dévie de ce que la conversation a obtenu ; rien n'est écrit, Excel n'est pas touché.",
    "reasoning": "Raisonnement",
    "plan": "Plan de modification",
    "planCalls_one": "{{count}} appel",
    "planCalls_other": "{{count}} appels",
    "tokens": "{{input}} tokens en entrée · {{output}} en sortie",
    "expandAll": "Tout déplier",
    "collapseAll": "Tout replier",
    "address": "Adresse",
    "before": "Avant",
    "written": "Écrit",
    "range": "Plage",
    "cells": "cellules",
    "pattern": "Motif R1C1",
    "whatWasWritten": "Ce qui a été écrit",
    "arguments": "Arguments",
    "result": "Résultat",
    "noResult": "Aucun résultat (l'appel n'a jamais répondu).",
    "truncated": "Coupé à 40 000 sur {{chars}} caractères.",
    "cellsChanged_one": "{{count}} cellule",
    "cellsChanged_other": "{{count}} cellules",
    "undone": "Annulé",
    "noBefore": "Pas d'état antérieur : le complément n'a pas enregistré d'annulation pour cette écriture.",
    "insightsTitle": "Qualité des conversations",
    "insightsSubtitle": "Ce que disent les utilisateurs, ce que font les conversations, ce qu'ont trouvé les revues.",
    "conversationsTitle": "Conversations",
    "period": "Période",
    "lastDays_one": "Dernier jour",
    "lastDays_other": "{{count}} derniers jours",
    "organization": "Organisation",
    "conversations": "Conversations",
    "conversation": "Conversation",
    "turnsHint_one": "{{count}} tour",
    "turnsHint_other": "{{count}} tours",
    "flagged": "Signalées",
    "flaggedHint": "{{count}} avec un pouce en bas ou un signal négatif",
    "satisfaction": "Satisfaction",
    "thumbsHint": "{{up}} pour · {{down}} contre",
    "responseRate": "Taux de réponse à la carte",
    "responseHint": "{{answered}} répondues · {{dismissed}} fermées",
    "successRate": "Taux de succès (revues)",
    "reviewedHint": "{{count}} revues",
    "reviewSpend": "Coût des revues",
    "reviewSpendHint": "À la charge de Peerception, non facturé",
    "sandboxSpend": "Coût des bacs à sable",
    "conversationsPerDay": "Conversations par jour",
    "flaggedPerDay": "Conversations signalées par jour",
    "failureReasons": "Causes d'échec (revues)",
    "misuse": "Détournements (revues)",
    "negativeTags": "Pourquoi les utilisateurs ont dit non",
    "signals": "Signaux",
    "outcomes": "Issues (revues)",
    "categories": "Ce que demandent les utilisateurs",
    "productInsights": "Enseignements produit",
    "perOrganization": "Par organisation",
    "thumbs": "Pour / contre",
    "reviewed": "Revues",
    "failures": "Échecs",
    "spend": "Coût fournisseur",
    "noReviews": "Aucune revue pour l'instant.",
    "noRatings": "Aucune note pour l'instant.",
    "searchHint": "Titre, e-mail ou id",
    "userRating": "Note de l'utilisateur",
    "outcomeLabel": "Issue",
    "severityLabel": "Gravité",
    "categoryLabel": "Catégorie",
    "reports": "Signalements",
    "reportFilter": { "any": "Déjà signalée" },
    "reportReason": { "wrong_result": "Chiffres ou formules faux", "damaged_workbook": "Classeur abîmé", "inappropriate": "Réponse inappropriée", "data_concern": "Données ou sécurité", "other": "Autre" },
    "evalCandidate": "Candidat à un eval",
    "eval": "Eval",
    "lastActivity": "Dernière activité",
    "user": "Utilisateur",
    "turns": "Tours",
    "verdict": "Revue",
    "cost": "Coût",
    "cardDismissed": "La carte de notation a été fermée.",
    "turn": "Tour {{index}}",
    "turnIndex": "index v{{version}}",
    "turnNoIndex": "sans index",
    "indexGone": "Index plus conservé",
    "replayRebuilt": "Le tour {{turn}} a été rejoué sur l'index v{{version}} reconstruit à partir de ses feuilles par le code actuel : le format de son catalogue a changé depuis.",
    "replayMissing": "Tour {{turn}} : l'index v{{version}} n'est plus conservé, ses opérations n'ont pas été rejouées.",
    "worstTurn": "Pire tour",
    "userSaid": "Utilisateur",
    "untitled": "Conversation sans titre",
    "intent": "Intention",
    "sentiment": "Ressenti",
    "selected": "Lue parce que",
    "selectedFlagged": "signalée",
    "selectedSample": "dans l'échantillon aléatoire",
    "reviewedAt": "Revue",
    "reviewFailed": "La revue a échoué ; elle est relancée si la conversation reprend.",
    "notReviewed": "Pas revue (ni signalée ni tirée au sort, ou pas encore au repos).",
    "noCardRating": "Aucune note de la conversation entière.",
    "facts": "Faits",
    "mode": "Mode",
    "workbook": "Classeur",
    "started": "Début",
    "noMessages": "Aucun message.",
    "costOf": { "agent": "Coût des tours", "index": "Coût de l'indexation", "review": "Coût des revues", "resume": "Coût du résumé de reprise", "sandbox": "Coût du bac à sable" },
    "rating": { "up": "Pour", "down": "Contre" },
    "outcome": { "success": "Succès", "partial": "Partiel", "failure": "Échec", "abandoned": "Abandonnée", "unclear": "Incertain" },
    "severity": { "none": "Aucune", "low": "Faible", "medium": "Moyenne", "high": "Élevée" },
    "category": { "build": "Construire", "modify": "Modifier", "explain": "Expliquer", "audit": "Auditer", "fix": "Corriger", "format": "Mettre en forme", "other": "Autre" },
    "reason": { "wrong_formula": "Formule fausse", "misunderstood": "Mal compris", "too_slow": "Trop lent", "broke_sheet": "Feuille cassée", "wrong_output": "Résultat faux", "too_many_steps": "Trop d'étapes", "tool_failure": "Échec d'outil", "gave_up": "A abandonné", "ignored_instruction": "Consigne ignorée", "hallucination": "Hallucination", "other": "Autre" },
    "tag": { "wrong_formula": "Formule fausse", "misunderstood": "Mal compris", "too_slow": "Trop lent", "broke_sheet": "Feuille cassée", "wrong_output": "Résultat faux", "too_many_steps": "Trop d'étapes", "accurate": "Exact", "understood": "Bien compris", "fast": "Rapide", "saved_time": "Gain de temps", "other": "Autre" },
    "misuseKind": { "off_scope": "Hors sujet", "extraction_attempt": "A demandé ses instructions", "injected_instruction": "Consigne dans le contenu" },
    "signal": { "reported": "Signalée", "error": "Erreur", "unavailable": "IA indisponible", "stalled": "Délai dépassé", "iteration_cap": "Limite d'étapes", "repeated_calls": "Étape répétée", "budget_cap": "Budget épuisé", "server_tool_error": "Erreur d'outil", "client_tool_error": "Refus d'Excel", "action_rejected": "Écriture refusée", "user_cancel": "Arrêtée par l'utilisateur", "undo": "Annulée", "thumbs_down": "Pouce en bas", "turn_started": "Tour commencé", "turn_done": "Tour terminé", "disclosure": "A recopié ses instructions" }
  },
  "billing": {
    "none": "Aucun abonnement",
    "subscription": "Abonnement",
    "offer": "Offre",
    "periodEnd": "Fin de période",
    "status": {
      "trialing": "Essai",
      "active": "Actif",
      "past_due": "Impayé",
      "ended": "Terminé",
      "canceled": "Résilié"
    },
    "period": {
      "label": "Période",
      "trial": "essai",
      "month": "mois"
    },
    "reason": {
      "packs_only": "Pas d'abonnement : l'assistant reste ouvert tant qu'il reste des crédits de packs, puis se ferme.",
      "no_subscription": "Aucun abonnement actif : l'assistant est fermé jusqu'au choix d'une offre.",
      "free_full": "Toutes les places Free étaient prises à la création de cette organisation : elle n'a pas d'abonnement tant que le staff ou un admin ne choisit pas d'offre.",
      "trial_ended": "L'essai est terminé : l'assistant est fermé jusqu'au paiement d'une offre.",
      "payment_overdue": "Un renouvellement est impayé : l'assistant est fermé jusqu'au paiement.",
      "member_cap_reached": "plafond du membre atteint",
      "user_cap_reached": "plafond par utilisateur atteint",
      "limit_reached": "usage inclus et crédits épuisés"
    },
    "pool": "Crédits mensuels",
    "credits": "Crédits",
    "price": "Prix",
    "free": "Gratuit",
    "perMonthHt": "/ mois HT",
    "perSeat": "par utilisateur / mois",
    "seats": "Places",
    "seatsUsed": "{{used}} utilisées sur {{seats}} (membres + invitations en attente)",
    "allowancePerSeat": "Crédits par place",
    "userCap": "Plafond par membre",
    "memberCap": "Plafond du membre",
    "startedAt": "Début",
    "grandfathered": "ancienne version",
    "trialDays": "essai, {{days}} jours",
    "scheduled": "Prévu en fin de période : {{offer}} × {{seats}}, le {{date}}.",
    "scheduledTier": "Prévu en fin de période : {{offer}} × {{seats}} avec le palier {{tier}}, le {{date}}.",
    "tier": "Palier de crédits",
    "tierPart": "{{price}} ({{usage}} de crédits)",
    "withTiers": "palier de crédits",
    "cancelsAt": "Résiliation en fin de période ({{date}}).",
    "setTitle": "Passer sur une offre maintenant",
    "setHint": "Action de l'équipe, sans commande : immédiate (une nouvelle version ou offre ouvre une nouvelle période ; la même version ne change que les places). Offres privées et anciennes versions incluses.",
    "switchesCurrency": "Cette version est en {{to}} : l'organisation passe de {{from}} à {{to}}, ce qui est refusé dès qu'elle a payé une commande.",
    "offerVersion": "Offre et version",
    "chooseVersion": "Choisir…",
    "applyNow": "Appliquer",
    "setConfirm": "{{name}} passe sur {{offer}} avec {{seats}} place(s) maintenant, sans commande. Une nouvelle période commence aujourd'hui.",
    "setSeatsConfirm": "{{name}} garde {{offer}}, désormais avec {{seats}} place(s). La période ne change pas.",
    "set": "Abonnement mis à jour.",
    "extendTitle": "Prolonger la période",
    "days": "Jours",
    "extendHint": "Un essai plus long, ou un délai avant renouvellement.",
    "extend": "Prolonger",
    "extended": "Période prolongée de {{days}} jour(s).",
    "grantTitle": "Offrir des crédits",
    "amountIn": "Montant ({{currency}})",
    "expires": "Expiration",
    "note": "Note",
    "notePlaceholder": "geste commercial, incident…",
    "grant": "Offrir",
    "granted": "Crédits offerts.",
    "creditsTitle": "Crédits",
    "source": "Origine",
    "remaining": "Restant",
    "noCredits": "Aucun crédit.",
    "expired": "expiré",
    "grantSource": {
      "pack": "Pack acheté",
      "staff": "Offert par l'équipe"
    },
    "prorated": "Au prorata : l'offre a changé le {{date}}, en cours de période, donc les crédits mensuels du nouveau palier ne comptent que pour les jours restants. {{full}} complets à partir du {{next}}."
  },
  "offers": {
    "title": "Offres",
    "subtitle": "Le catalogue : les offres publiques sont sur la page de tarifs ; les privées servent aux accords posés à la main.",
    "new": "Nouvelle offre",
    "newSubtitle": "Les conditions de sa première version restent modifiables tant que personne n'y a souscrit.",
    "identity": "Offre",
    "terms": "Conditions",
    "key": "Clé",
    "keyHint": "Minuscules, chiffres, tirets ; ne change jamais.",
    "currency": "Devise",
    "currencyHint": "Tous les montants de l'offre y sont exprimés ; fixée à la création. La même clé dans une autre devise est une autre offre.",
    "name": "Nom",
    "description": "Description",
    "descriptionHint": "Affichée sur la page de tarifs.",
    "sort": "Ordre",
    "placesLimit": "Places",
    "placesTaken": "Abonnements en cours autorisés en même temps ; prises : {{places}}. Vide = sans limite.",
    "version": "Version",
    "publicHint": "Publique : sur la page de tarifs, les clients peuvent la choisir",
    "activeHint": "Active : on peut y souscrire",
    "public": "publique",
    "private": "privée",
    "inactive": "inactive",
    "older": "ancienne version",
    "visibility": "Visibilité",
    "subscribers": "Abonnés",
    "seats": "Places",
    "isTrial": "Offre d'essai (gratuite, pour un nombre de jours, sans renouvellement)",
    "trialDays": "Durée de l'essai (jours)",
    "trialFor": "essai · {{days}} jours",
    "pricePerSeat": "Prix par utilisateur / mois",
    "pricePerSeatHint": "Dans la devise de l'offre, hors taxes.",
    "allowancePerSeat": "Crédits par utilisateur / mois",
    "trialAllowance": "Crédits pour tout l'essai",
    "allowanceHint": "Dans la devise de l'offre au prix client, ajoutés aux crédits mensuels de l'organisation. Vide = illimité.",
    "userCap": "Plafond par membre / mois",
    "userCapHint": "Ce qu'un membre peut consommer des crédits mensuels. Vide = pas de plafond.",
    "noCap": "pas de plafond",
    "minSeats": "Utilisateurs min.",
    "maxSeats": "Utilisateurs max.",
    "maxSeatsHint": "Vide = pas de maximum.",
    "tiers": "Paliers de crédits",
    "tiersHint": "Prix mensuel HT → crédits qu'il donne (au prix client), tous deux dans la devise de l'offre, ajoutés au prix des sièges et aux crédits mensuels. Aucun = pas de choix.",
    "tierPrice": "Prix",
    "tierUsage": "Crédits",
    "addTier": "Ajouter un palier",
    "removeTier": "Retirer ce palier",
    "features": "Arguments",
    "featuresHint": "Un par ligne, affichés sur la page de tarifs (12 au plus).",
    "keyAndNameRequired": "La clé et le nom sont obligatoires.",
    "detailSubtitle": "Version courante : v{{version}} · {{count}} abonné(s) en cours sur ses versions.",
    "currentTerms": "Conditions courantes (v{{version}})",
    "lockedNotice": "La version {{version}} est utilisée ({{count}} abonné(s)) : enregistrer crée la version {{version}} + 1 pour les nouveaux abonnés ; les abonnés actuels gardent la version {{version}} jusqu'à leur migration.",
    "unlockedNotice": "Personne n'a encore souscrit à cette version : elle se modifie sur place.",
    "saveAsNewVersion": "Enregistrer en version {{version}}",
    "newVersionTitle": "Créer la version {{version}}",
    "newVersionMessage": "Les nouveaux abonnements prendront les nouvelles conditions. Les {{count}} abonné(s) actuel(s) de la version {{version}} gardent leurs conditions jusqu'à leur migration.",
    "versionCreated": "Version {{version}} créée ; les abonnés actuels gardent leur version.",
    "termsSaved": "Version {{version}} enregistrée.",
    "versions": "Versions",
    "versionsHint": "Une version est figée dès qu'un abonnement l'a utilisée. Migrer déplace ses abonnés vers une autre version à leur premier renouvellement après la date choisie ; leurs administrateurs sont prévenus par e-mail dès maintenant.",
    "current": "courante",
    "createdAt": "Créée",
    "locked": "Figée",
    "migrate": "Migrer les abonnés",
    "migrateTitle": "Migrer la version {{version}} ({{count}} abonné(s))",
    "migrateMessage": "Aujourd'hui ou avant : chaque abonnement change maintenant et garde sa période ; le prochain renouvellement facture les nouvelles conditions. Une date future : il change à son premier renouvellement à partir de cette date. Ses administrateurs reçoivent un préavis maintenant, avec la date réelle.",
    "migrateTo": "Vers la version",
    "migrateFrom": "À partir du",
    "migrateFromHint": "Prévoir au moins {{days}} jours de préavis.",
    "migrated": "{{count}} abonnement(s) changeront à leur premier renouvellement à partir du {{date}}.",
    "migratedNow": "{{count}} abonnement(s) passés maintenant à la nouvelle version."
  },
  "packs": {
    "title": "Packs de crédits",
    "subtitle": "Des crédits prépayés, achetés une fois les crédits mensuels épuisés. Consommés par date d'expiration.",
    "new": "Nouveau pack",
    "name": "Nom",
    "price": "Prix",
    "priceHint": "Dans la devise du pack, hors taxes.",
    "credit": "Crédits",
    "creditHint": "Dans la devise du pack, au prix client.",
    "validity": "Validité",
    "validityHint": "Mois après paiement ; vide = sans expiration.",
    "noExpiry": "sans expiration",
    "months": "{{count}} mois",
    "publicHint": "Public : achetable depuis le portail",
    "activeHint": "Actif : peut être acheté",
    "editHint": "Les changements valent pour les nouvelles commandes ; les commandes en attente gardent leur prix, les crédits achetés leur montant."
  },
  "prices": {
    "title": "Prix",
    "subtitle": "Les devises dans lesquelles Sculpt est vendu, leurs taux, et chaque offre et pack tarifés dans chaque devise. Effet immédiat, sans déploiement.",
    "currencies": "Devises",
    "currency": "Devise",
    "rate": "Taux",
    "onSale": "En vente",
    "notOnSale": "pas en vente",
    "fixed": "fixe",
    "updated": "Mis à jour",
    "rateHint": "Le taux est ce que vaut une unité en euros (USD 0,90 : un dollar vaut 0,90 €). Il traduit dans cette devise le prix d'une requête, compté en euros ; le taux USD convertit aussi en euros ce que facturent les fournisseurs payés en dollars (Anthropic). Les prix des offres n'en sont pas convertis : ceux de chaque devise se fixent dans le tableau ci-dessous. Une devise en vente peut être proposée aux clients.",
    "rateChangeHint": "Changer un taux ne touche que le prix des requêtes suivantes, dans cette devise (et, pour l'USD, de toutes les requêtes Anthropic). Aucun solde ne bouge.",
    "newCode": "Code",
    "addCurrency": "Ajouter une devise",
    "addHint": "Commence hors vente : tarifez-la ci-dessous, puis mettez-la en vente.",
    "badCode": "Un code de devise a trois lettres (USD, GBP).",
    "badRate": "Le taux doit être un nombre supérieur à zéro.",
    "codeListed": "{{code}} est déjà listée : changez son taux sur sa ligne.",
    "currencySaved": "Devise enregistrée.",
    "delete": "Supprimer",
    "deleteTitle": "Supprimer {{code}} ?",
    "deleteMessage": "Seule une devise que rien n'utilise peut être supprimée : aucune organisation, offre, pack, commande, facture, requête ni crédit dans cette devise. L'USD reste : son taux sert aussi au coût d'Anthropic.",
    "deleteOnSale": "Retirez-la d'abord de la vente.",
    "currencyDeleted": "Devise supprimée.",
    "table": "Tableau des prix",
    "tableHint": "Chaque colonne est une devise, modifiée à part. « — » = pas de prix dans cette devise. Les montants sont dans la devise de la colonne.",
    "editing": "Modification des prix en {{currency}}",
    "editHint": "Une ligne laissée entièrement vide n'est pas créée. Une ligne pas encore en {{currency}} est créée à partir de celle en euros (nom, visibilité, sièges, fonctionnalités), ses valeurs en euros affichées en référence. Allocation vide = illimitée, plafond vide = sans plafond, crédits d'un palier vides = son prix. De nouvelles conditions sur une offre qui a des abonnés créent une nouvelle version ; ils gardent la leur.",
    "offers": "Offres",
    "packs": "Packs de crédits",
    "tier": "Palier {{n}}",
    "noCap": "sans plafond",
    "fromEur": "à créer depuis EUR",
    "versionMeta_one": "v{{version}} · {{count}} abonné",
    "versionMeta_other": "v{{version}} · {{count}} abonnés",
    "incomplete": "{{name}} : remplissez chaque montant de la ligne, ou laissez-la entièrement vide.",
    "pricesSaved": "Prix en {{currency}} enregistrés.",
    "unpricedOnSale": "{{currency}} est en vente mais n'a pas de prix pour : {{names}}. Les clients en {{currency}} ne peuvent pas les acheter."
  },
  "orders": {
    "title": "Commandes",
    "subtitle": "Ce que les organisations ont acheté ou doivent. Marquez une commande payée à réception du paiement : elle prend effet aussitôt.",
    "organization": "Organisation",
    "kindLabel": "Type",
    "statusLabel": "Statut",
    "what": "Objet",
    "amount": "Montant (HT)",
    "vat": "TVA",
    "total": "Total (TTC)",
    "createdAt": "Créée",
    "paidAt": "Payée",
    "payment": "Paiement",
    "showPayments": "Paiements",
    "hidePayments": "Masquer",
    "kind": {
      "subscribe": "Abonnement",
      "change": "Changement d'offre",
      "seats": "Places",
      "renewal": "Renouvellement",
      "pack": "Pack de crédits"
    },
    "status": {
      "pending": "En attente",
      "paid": "Payée",
      "canceled": "Annulée",
      "failed": "Échouée"
    },
    "none": "Aucune commande.",
    "markPaid": "Marquer payée",
    "markPaidTitle": "Marquer la commande n° {{id}} payée",
    "markPaidMessage": "Uniquement une fois le paiement reçu. La commande prend effet maintenant (abonnement, places, crédits ou réactivation) et le client est prévenu par e-mail.",
    "paid": "Commande payée et appliquée.",
    "canceled": "Commande annulée.",
    "draftInvoice": "Brouillon de facture",
    "openInvoice": "Facture"
  },
  "errors": {
    "restricted_conversation": "Cette conversation ne s'ouvre que pour une demande de support.",
    "order_not_paid": "Seule une commande payée peut être remboursée.",
    "invalid_effect": "Cet effet ne s'applique pas à ce type de commande.",
    "invalid_amount": "Le montant doit être supérieur à zéro.",
    "amount_too_high": "Le montant dépasse ce qui reste à rembourser sur cette commande.",
    "invoice_not_issued": "La facture de cette commande n'est pas encore émise : l'avoir a besoin de son numéro. Réessayez dans quelques minutes.",
    "refund_refused_by_mollie": "Mollie a refusé le remboursement (montant déjà remboursé ou paiement non remboursable) : vérifiez dans Mollie.",
    "no_saved_card": "Cette organisation n'a pas de carte enregistrée.",
    "payment_provider_unavailable": "Mollie ne répond pas pour le moment : réessayez dans quelques minutes.",
    "vat_review_pending": "La TVA de cette commande attend la vérification du numéro de TVA : tranchez-le d'abord (TVA à vérifier).",
    "invalid_country": "Le pays doit être un code ISO à deux lettres.",
    "invalid_customer_kind": "Le client est une société ou un entrepreneur individuel.",
    "invalid_siren": "Un SIREN compte 9 chiffres.",
    "invalid_vat_number": "Ce numéro de TVA est mal formé.",
    "vat_country_mismatch": "Le numéro de TVA doit commencer par le préfixe du pays de facturation (Grèce : EL, Monaco : FR).",
    "no_vat_number": "L'organisation n'a pas de numéro de TVA.",
    "manual_invoicing_retired": "Les factures sont désormais émises via Qonto pour chaque commande payée : on ne peut plus en créer à la main.",
    "issued_by_qonto": "Cette facture a été émise via Qonto : elle ne se modifie que par un avoir.",
    "not_failed": "Seule une facture en échec peut être relancée.",
    "not_creditable": "Seule une facture émise via Qonto peut faire l'objet d'un avoir.",
    "already_credited": "Cette facture a déjà un avoir.",
    "currency_locked": "La devise ne peut plus changer : l'organisation a payé une commande dans celle-ci.",
    "currency_not_supported": "Aucun taux de change n'est configuré pour cette devise.",
    "currency_fixed": "La devise d'une offre ne change pas : créez l'offre dans l'autre devise.",
    "currency_mismatch": "La cible est dans une autre devise.",
    "key_taken": "Cette clé est déjà utilisée dans cette devise.",
    "eur_fixed": "L'euro est la devise du grand livre : son taux est fixé à 1 et il est toujours en vente.",
    "tiers_mismatch": "Une offre à paliers en euros doit avoir autant de paliers dans cette devise (les paliers se correspondent par rang).",
    "reference_missing": "Aucune offre ni aucun pack en euros n'a cette clé pour servir de modèle : créez-le d'abord en euros.",
    "duplicate_tier": "Deux paliers d'une offre ont le même prix.",
    "usd_prices_providers": "L'USD ne peut pas être supprimé : son taux sert aussi à convertir ce qu'Anthropic facture en dollars.",
    "currency_on_sale": "Retirez la devise de la vente avant de la supprimer.",
    "currency_in_use": "Cette devise est utilisée (organisation, offre, pack, commande, facture, requête ou crédit) : elle ne peut pas être supprimée."
  },
  "profile": {
    "hint": "Sculpt est vendu uniquement aux professionnels. La TVA de chaque commande suit ce profil : le pays et, ailleurs dans l'UE, le numéro de TVA vérifié par VIES.",
    "complete": "prêt à facturer",
    "incomplete": "incomplet",
    "kindLabel": "Client",
    "kind": {
      "company": "Société",
      "individual": "Entrepreneur individuel"
    },
    "nameIndividual": "Prénom et nom",
    "street": "Rue",
    "zip": "Code postal",
    "city": "Ville",
    "country": "Pays",
    "siren": "SIREN",
    "sirenHint": "Obligatoire pour un client français (9 chiffres).",
    "registration": "Numéro d'immatriculation",
    "registrationHint": "Client hors de France, facultatif : imprimé tel quel sur ses factures. Ignoré pour un client français (SIREN).",
    "paymentMethod": "Paiement",
    "payment": {
      "card": "Carte",
      "transfer": "Virement"
    },
    "transferHint": "Réservé à l'équipe : les commandes sont marquées payées à la main. Aucun écran ne le propose au client.",
    "legacyAddress": "Ancienne adresse (texte libre)",
    "legacyAddressHint": "Conservée d'avant l'adresse structurée ; ni la TVA ni les factures ne l'utilisent."
  },
  "payments": {
    "kind": "Type",
    "online": "Paiement en ligne",
    "recurring": "Prélèvement automatique",
    "revoke": "Révoquer la carte",
    "revokeTitle": "Révoquer la carte enregistrée ?",
    "revokeMessage": "La carte {{card}} ne sera plus débitée automatiquement : les prochains renouvellements devront être payés à la main par le client, depuis son espace. Le mandat est révoqué chez Mollie.",
    "revoked": "Carte révoquée : les renouvellements ne seront plus débités automatiquement.",
    "title": "Paiements par carte de la commande n° {{id}}",
    "none": "Aucun paiement par carte pour cette commande.",
    "byCard": "Carte",
    "status": {
      "open": "En cours",
      "pending": "En attente",
      "authorized": "Autorisé",
      "paid": "Payé",
      "failed": "Échoué",
      "canceled": "Annulé",
      "expired": "Expiré"
    },
    "attempt": "Tentative",
    "amount": "Montant (TTC)",
    "card": "Carte",
    "failure": "Motif de l'échec",
    "createdAt": "Créé le",
    "paidAt": "Payé le",
    "expiresAt": "Expire le",
    "dashboard": "Voir dans Mollie",
    "cardTitle": "Carte enregistrée",
    "noCard": "Aucune carte enregistrée : l'organisation n'a pas encore payé par carte.",
    "cardLabel": "Carte",
    "cardExpires": "Expire le",
    "customer": "Client Mollie",
    "mandate": "Mandat"
  },
  "vat": {
    "title": "TVA à vérifier",
    "subtitle": "Les numéros de TVA auxquels VIES n'a pas pu répondre. Leurs commandes sont bloquées jusqu'à votre décision, ou jusqu'à ce que VIES réponde lors d'un passage suivant.",
    "none": "Aucun numéro de TVA en attente.",
    "onRecord": "Fiche VIES",
    "noAnswer": "pas encore de réponse",
    "since": "Depuis",
    "held": "Commandes bloquées",
    "heldOrders_one": "{{count}} commande · {{amount}}",
    "heldOrders_other": "{{count}} commandes · {{amount}}",
    "status": {
      "none": "non vérifié",
      "valid": "valide",
      "invalid": "non valide",
      "review": "à vérifier"
    },
    "scheme": {
      "reverse_charge": "Autoliquidation",
      "outside_scope": "TVA non applicable",
      "review": "En attente de vérification TVA"
    },
    "rate": "{{rate}} %",
    "markValid": "Numéro valide",
    "markInvalid": "Numéro non valide",
    "validTitle": "{{number}} est valide",
    "invalidTitle": "{{number}} n'est pas valide",
    "validMessage": "Le client est en autoliquidation (0 %). Les commandes bloquées deviennent payables et les administrateurs de l'organisation sont prévenus par e-mail.",
    "invalidMessage": "Le client paie la TVA française (20 %). Les commandes bloquées deviennent payables et les administrateurs de l'organisation sont prévenus par e-mail.",
    "decided": "Numéro de TVA {{status}}.",
    "decidedReleased": "Numéro de TVA {{status}} ; commandes désormais payables : {{orders}}.",
    "cardTitle": "Numéro de TVA {{number}}",
    "recheck": "Revérifier avec VIES",
    "reviewHint": "VIES n'a pas pu répondre pour ce numéro : ses commandes sont bloquées. Vérifiez les informations de la société, puis tranchez.",
    "checkedAt": "Vérifié par VIES",
    "registeredName": "Nom enregistré",
    "registeredAddress": "Adresse enregistrée",
    "consultation": "N° de consultation",
    "settled": "Tranché",
    "settledByStaff": "par l'équipe, {{date}}",
    "settledByVies": "par VIES, {{date}}",
    "salesTitle": "Ventes à distance dans l'UE",
    "salesHint": "Commandes facturées avec la TVA française à des clients ailleurs dans l'UE sans numéro de TVA confirmé. Au-delà de {{threshold}} sur une année, la TVA du pays du client s'applique dès la vente qui franchit le seuil (guichet OSS).",
    "salesWarning": "au-delà de l'alerte à {{warning}}",
    "salesOver": "au-delà du seuil"
  },
  "refunds": {
    "show": "Remboursements",
    "hide": "Masquer",
    "title": "Remboursements de la commande n° {{id}}",
    "none": "Aucun remboursement pour cette commande.",
    "when": "Date",
    "amount": "Montant TTC",
    "how": "Moyen",
    "status": "Statut",
    "reason": "Motif",
    "effect": "Effet",
    "creditNote": "Avoir",
    "openCreditNote": "Ouvrir l'avoir",
    "toCard": "Carte (Mollie)",
    "byTransfer": "Virement (par vous)",
    "statuses": {
      "queued": "En file",
      "pending": "En cours",
      "processing": "En traitement",
      "refunded": "Remboursé",
      "failed": "Échoué",
      "canceled": "Annulé"
    },
    "effects": {
      "none": "Aucun",
      "cancel_at_period_end": "Résilier à la fin de la période",
      "cancel_now": "Résilier maintenant",
      "remove_credits": "Reprendre les crédits non utilisés"
    },
    "hintCard": "L'argent est rendu sur la carte du client par Mollie, et un avoir du même montant est émis dans Qonto. Reste à rembourser : {{left}}.",
    "hintTransfer": "Commande payée par virement : un avoir est émis dans Qonto, mais c'est à vous d'envoyer l'argent au client. Reste à rembourser : {{left}}.",
    "amountLabel": "Montant TTC",
    "amountHint": "Au plus {{left}}.",
    "reasonLabel": "Motif",
    "reasonHint": "Imprimé sur l'avoir.",
    "effectLabel": "Effet sur l'abonnement ou les crédits",
    "refund": "Rembourser",
    "confirmTitle": "Rembourser la commande n° {{id}} ?",
    "confirmCard": "{{amount}} seront rendus sur la carte du client par Mollie, et un avoir de ce montant sera émis dans Qonto. Cette opération ne peut pas être annulée.",
    "confirmTransfer": "Un avoir de {{amount}} sera émis dans Qonto. La commande a été payée par virement : envoyez vous-même l'argent au client.",
    "done": "Remboursement de {{amount}} enregistré.",
    "rounded": "Le montant a été arrondi au centime inférieur : c'est le plus proche qu'un avoir sur une ligne puisse afficher.",
    "nothingLeft": "Tout a été remboursé sur cette commande.",
    "chargeback": "Contestation (chargeback)"
  },
  "monthly": {
    "title": "Mois",
    "subtitle": "Les commandes payées, les remboursements et les contestations du mois, pour rapprocher les versements de Mollie et le compte bancaire.",
    "month": "Mois",
    "currency": "Devise",
    "paidOrders": "Commandes payées",
    "amount": "Total HT",
    "vat": "TVA",
    "total": "Total TTC",
    "byCard": "Dont par carte",
    "byCardHint": "À retrouver dans les versements Mollie (moins ses frais).",
    "byTransfer": "Dont par virement",
    "refunds_one": "{{count}} remboursement",
    "refunds_other": "{{count}} remboursements",
    "chargebacks_one": "{{count}} contestation",
    "chargebacks_other": "{{count}} contestations"
  },
  "issues": {
    "title": "Problèmes",
    "new": "Nouveau problème",
    "create": "Créer",
    "newFromThis": "Nouveau problème",
    "linkToIssue": "Lier à un problème…",
    "titleLabel": "Titre",
    "titlePlaceholder": "Ce qui ne va pas, en une ligne",
    "descriptionLabel": "Description",
    "noDescription": "Pas encore de description.",
    "severityLabel": "Gravité",
    "statusLabel": "Statut",
    "labelsLabel": "Étiquettes",
    "labelsHint": "Séparées par des virgules",
    "searchOpen": "Chercher parmi les problèmes ouverts",
    "searchHint": "Titre, description ou #numéro",
    "noneFound": "Aucun problème ouvert ne correspond.",
    "status": { "open": "Ouvert", "investigating": "En analyse", "fixed": "Corrigé", "wont_fix": "Ne sera pas corrigé", "duplicate": "Doublon" },
    "severity": { "low": "Faible", "medium": "Moyenne", "high": "Haute", "critical": "Critique" },
    "statusFilter": { "open": "Ouverts et en analyse", "closed": "Fermés", "all": "Tous" },
    "issueFilter": { "open": "Un problème ouvert", "any": "Un problème", "none": "Aucun problème" },
    "evidence": "Éléments",
    "affected": "Utilisateurs · orgs",
    "affectedValue": "{{users}} · {{orgs}}",
    "owner": "Responsable",
    "nobody": "Personne",
    "lastSeen": "Vu pour la dernière fois",
    "updated": "Dernière modification",
    "closed": "Fermé",
    "users": "Utilisateurs",
    "organizations": "Organisations",
    "reach": "Portée",
    "kind": { "conversation": "Conversation", "report": "Signalement", "review": "Revue", "signal": "Signal" },
    "kindPlural": { "conversation": "Conversations", "report": "Signalements", "review": "Revues", "signal": "Signaux" },
    "kindCount": { "conversation_one": "{{count}} conversation", "conversation_other": "{{count}} conversations", "report_one": "{{count}} signalement", "report_other": "{{count}} signalements", "review_one": "{{count}} revue", "review_other": "{{count}} revues", "signal_one": "{{count}} signal", "signal_other": "{{count}} signaux" },
    "evidenceTitle_one": "Éléments ({{count}})",
    "evidenceTitle_other": "Éléments ({{count}})",
    "noEvidence": "Rien de lié pour l'instant.",
    "notFound": "N'existe plus",
    "unlink": "Délier",
    "linkKind": "Type",
    "linkRef": "Référence",
    "linkRefHint": "Id du fil, ou numéro du signalement, de la revue ou du signal",
    "addLink": "Lier",
    "timeline": "Historique",
    "comment": "Commenter",
    "commentPlaceholder": "Constats, reproduction, prochaine étape…",
    "edited": "modifié",
    "workflow": "Suivi",
    "duplicateOf": "Doublon de #",
    "fixRefs": "Correction",
    "fixLabel": "MR, commit ou version (ex. sculpt-api !131)",
    "addFix": "Ajouter",
    "remove": "Retirer",
    "openedBy": "Ouvert par {{who}}",
    "backToList": "Tous les problèmes",
    "editTitle": "Modifier le problème",
    "reportTitle": "Signalement",
    "noneOnConversation": "Aucun problème sur cette conversation.",
    "openBadge_one": "{{count}} problème",
    "openBadge_other": "{{count}} problèmes",
    "openStat": "Problèmes ouverts",
    "openStatHint": "{{reports}} signalements · {{opened}} ouverts · {{closed}} fermés sur la période",
    "resolve": "Résoudre",
    "resolveTitle": "Résoudre le problème",
    "resolutionHint": { "fixed": "Le problème a disparu : dites ce qui l'a corrigé", "wont_fix": "Connu, et restera tel quel", "duplicate": "Un autre problème le couvre déjà" },
    "fixedBy": "Corrigé par",
    "fixUrl": "Lien",
    "optional": "Facultatif",
    "resolveNote": "Note",
    "resolveNoteHint": "Ajoutée à l'historique comme commentaire",
    "resolveNotePlaceholder": "Ce qui a été trouvé, ce qui a changé",
    "resolveAs": "Résoudre : {{status}}",
    "reopen": "Rouvrir",
    "closedAs": { "fixed": "Corrigé", "wont_fix": "Ne sera pas corrigé", "duplicate": "Doublon" },
    "closedByLine": "par {{who}}, {{when}}",
    "via": { "report": "Un signalement", "review": "Revue ({{model}})" },
    "openedVia": { "report": "Ouvert par un signalement", "review": "Ouvert par la revue" },
    "event": { "created": "a ouvert le problème, gravité {{severity}}", "title": "a changé le titre", "description": "a changé la description", "commentEdited": "a modifié un commentaire", "status": "statut {{from}} → {{to}}", "severity": "gravité {{from}} → {{to}}", "owner": "responsable {{from}} → {{to}}", "labels": "étiquettes {{from}} → {{to}}", "fixRefs": "correction {{from}} → {{to}}", "linked": "a lié : {{kind}}", "unlinked": "a délié : {{kind}}" },
    "regression": "régression",
    "beforeAfter": "Avant / après",
    "before": "Avant",
    "after": "Après",
    "exportForClaude": "Exporter pour Claude (.md)",
    "copyForClaude": "Copier pour Claude",
    "copied": "Copié",
    "exportHelp": "Le problème, son historique et les transcriptions de ses conversations en Markdown. Chaque conversation exportée est tracée dans l'audit."
  },
  "sandbox": {
    "fromHere": "Bac à sable d'ici",
    "fromHereHelp": "Ouvrir un bac à sable à partir de ce message : le classeur tel qu'il était alors et la conversation qui précède. L'utilisateur ne voit rien et ne paie rien.",
    "notRecorded": "Ce tour précède l'enregistrement de sa version d'index : il ne peut pas être copié.",
    "openButton": "Ouvrir en bac à sable",
    "openHelp": "Ouvrir un bac à sable à partir du premier tour qui peut être copié. Pour partir d'un autre message, utilisez « Bac à sable d'ici » dessus.",
    "nothingPlayable": "Aucun tour de cette conversation ne peut être copié : ses versions d'index ne sont plus conservées, ou elle précède leur enregistrement.",
    "reason": "Raison",
    "approveAllLabel": "Approuver chaque confirmation (sinon chacune vous attend)",
    "title": "Bac à sable",
    "listTitle": "Bacs à sable",
    "listSubtitle": "Des conversations copiées pour que l'équipe les rejoue. Chacune est supprimée 30 jours après son dernier tour.",
    "none": "Aucun bac à sable pour l'instant.",
    "conversation": "Conversation",
    "staff": "Équipe",
    "model": "Modèle",
    "turnsPlayed": "Tours",
    "fromTo": "depuis {{from}}, prochain {{next}}",
    "cost": "Coût (Peerception)",
    "state": "État",
    "states": { "idle": "Au repos", "running": "En cours", "waiting": "Vous attend", "failed": "Échec" },
    "lastActivity": "Dernière activité",
    "about": "Ce bac à sable",
    "startedAt": "Commencé au",
    "startedAtValue": "tour {{turn}}, index v{{version}}",
    "approveAll": "Approuve chaque confirmation",
    "expires": "Supprimé après",
    "recordedTurns": "Ce que l'utilisateur a envoyé",
    "documents_one": "{{count}} pièce jointe",
    "documents_other": "{{count}} pièces jointes",
    "play": "Rejouer",
    "playNext": "Rejouer le tour {{index}}",
    "noNext": "Tous les tours enregistrés ont été rejoués",
    "waitingQuestion": "L'agent pose une question",
    "waitingConfirmation": "Ces appels attendent une confirmation",
    "answer": "Répondre",
    "approve": "Approuver",
    "refuse": "Refuser",
    "running": "Le tour est en cours…",
    "yourMessage": "Votre message",
    "messagePlaceholder": "Demandez quelque chose à l'agent dans ce bac à sable…",
    "send": "Envoyer",
    "cancel": "Arrêter le tour",
    "delete": "Supprimer",
    "deleteTitle": "Supprimer ce bac à sable ?",
    "deleteMessage": "Sa copie du classeur et sa conversation sont supprimées. La conversation de l'utilisateur n'est pas touchée.",
    "fidelityFunctions": "Pas calculé comme Excel le ferait : le simulateur n'a pas {{functions}} ({{cells}} cellules recalculées).",
    "fidelityLoops_one": "Une référence circulaire a été calculée à 0 (calcul itératif désactivé ou inconnu) : {{count}} cellule.",
    "fidelityLoops_other": "Des références circulaires ont été calculées à 0 (calcul itératif désactivé ou inconnu) : {{count}} cellules.",
    "comparison": "Rejoué à côté de ce qui s'est passé",
    "comparedTurns": "tour {{recorded}} de l'utilisateur · tour {{sandbox}} du bac à sable",
    "sameTools": "Mêmes outils",
    "otherTools": "Autres outils",
    "samePlans": "Mêmes plans",
    "otherPlans": "Autres plans",
    "pane": { "recorded": "Tour {{index}} de l'utilisateur", "typed": "Écrit par l'équipe", "thinking": "Réflexion…", "reading": "Lecture du modèle…", "planning": "Préparation de la modification…", "excel": "Travail dans Excel…", "waiting": "Vous attend", "userTook": "tour de l'utilisateur : {{time}}", "committed": "enregistré en v{{version}}", "failed": "échec", "cancelled": "arrêté", "running": "en cours", "waitingState": "en attente", "details": "détails", "hideDetails": "masquer les détails" },
    "recorded": "Utilisateur",
    "sandbox": "Bac à sable"
  }
}
